import React, { useEffect, useRef } from 'react';

// Painting name that follows the mouse. It tracks the mouse itself and moves via a ref,
// so mouse movement never re-renders the app (and with it the whole 3D scene).
const HoverTooltip = ({ painting }) => {
  const ref = useRef();
  useEffect(() => {
    const move = (e) => {
      if (ref.current) ref.current.style.transform = `translate(${e.clientX + 15}px, ${e.clientY - 60}px)`;
    };
    window.addEventListener('mousemove', move);
    return () => window.removeEventListener('mousemove', move);
  }, []);

  if (!painting) return null;
  return (
    <div ref={ref} className="fixed left-0 top-0 bg-black/80 text-white p-3 rounded-lg pointer-events-none z-50 fade-in" style={{ transform: 'translate(-9999px, 0)' }}>
      <div className="text-sm font-medium">{painting.title}</div>
      <div className="text-xs text-gray-300">{painting.subtitle || `by ${painting.artist}`}</div>
    </div>
  );
};

export default HoverTooltip;
